
// features/branches/branchesThunks.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export interface IBranch {
    cardId: string;
    customSlug: string;
    company: {
        am: string;
        ru: string;
        en: string;
    };
    phone: string;
    address: {
        am: string;
        ru: string;
        en: string;
    };
    location: string;
}

export const fetchBranches = createAsyncThunk<IBranch[], { userId: string; excludeCardId?: string }>(
    'frontGlobals/fetchBranches',
    async ({ userId, excludeCardId }, { rejectWithValue }) => {
        try {
            const params = excludeCardId ? `?excludeCardId=${excludeCardId}` : '';
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/users/branches/${userId}${params}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data || 'Failed to fetch branches'
            );
        }
    }
);